module.exports = __webpack_public_path__ + "static/img/caseContent.cf97c4d2.png";